import styled from 'styled-components';

export const Container = styled.section`
	width: 100%;
	height: 100%;
	padding: 5em 0;
	position: relative;
	z-index: 0;
`;
